import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import addWalletImg from "../../styles/images/img_add_wallet.png";

const DontHaveWallet = () => {
  const navigate = useNavigate();
  return (
    <Section>
      <Content>
        <TextDiv>
          <h3>
            AMO 포인트 교환을 위해
            <br />
            <span className="col">부리또 웰렛</span>의 주소를 등록해주세요.
          </h3>
        </TextDiv>

        <ImgWrap margintop="9.7" imgwidth="26.8">
          <img src={addWalletImg} alt="" />
        </ImgWrap>
      </Content>
      <Btns>
        <ButtonL onClick={() => navigate("/amo/wallet/check")}>
          주소를 등록해주세요
        </ButtonL>
      </Btns>
    </Section>
  );
};

export default DontHaveWallet;
